import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { renderMarkers } from './markers';
import { renderWrappedText } from './textUtils';
import { renderAiChip } from './aiChip';
import { getThemeStyle } from '../theme';

class ServiceTaskView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height, radius } = model;
    const style = model.getNodeStyle();
    const props = model.properties || {};

    // Gear icon position (top-left corner)
    const ix = x - width / 2 + 10;
    const iy = y - height / 2 + 10;
    const clr = style.stroke;

    // Helper: generate gear tooth path as a closed polygon
    const gearPath = (cx, cy, innerR, outerR, teeth) => {
      const pts = [];
      const step = Math.PI / teeth;
      for (let i = 0; i < teeth * 2; i++) {
        const angle = i * step - Math.PI / 2;
        const r = i % 2 === 0 ? outerR : innerR;
        pts.push(`${cx + r * Math.cos(angle)},${cy + r * Math.sin(angle)}`);
      }
      return `M ${pts.join(' L ')} Z`;
    };

    const children = [
      h('rect', {
        x: x - width / 2,
        y: y - height / 2,
        width,
        height,
        rx: radius,
        ry: radius,
        ...style,
      }),
      // BPMN Service icon — two interlocking gears
      // Gear 1 (larger, bottom-left)
      h('path', {
        d: gearPath(ix, iy + 2, 4, 6.5, 8),
        fill: 'none', stroke: clr, strokeWidth: 1,
      }),
      h('circle', { cx: ix, cy: iy + 2, r: 2, fill: 'none', stroke: clr, strokeWidth: 0.8 }),
      // Gear 2 (smaller, top-right, interlocking)
      h('path', {
        d: gearPath(ix + 6, iy - 3, 3, 5, 8),
        fill: 'none', stroke: clr, strokeWidth: 1,
      }),
      h('circle', { cx: ix + 6, cy: iy - 3, r: 1.5, fill: 'none', stroke: clr, strokeWidth: 0.8 }),
    ];

    // Wrapped text inside the shape
    const label = (props && props.name) || '';
    if (label) {
      children.push(renderWrappedText(h, label, x, y + 4, width - 20, { graphModel: model.graphModel }));
    }

    children.push(...renderMarkers(x, y, width, height, props, style.stroke));

    const chip = renderAiChip(x, y, width, height, props);
    if (chip) children.push(chip);

    return h('g', {}, children);
  }
}

class ServiceTaskModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 120;
    this.height = 60;
    this.radius = 5;
    this.text = { ...this.text, editable: false, draggable: false, value: '' };
  }


  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'serviceTask');
    style.stroke = t.stroke || '#722ed1';
    style.strokeWidth = t.strokeWidth ?? 1;
    style.fill = t.fill || '#f9f0ff';
    return style;
  }
}

export const ServiceTask = {
  type: 'epx:ServiceTask',
  view: ServiceTaskView,
  model: ServiceTaskModel,
};
